import { useState, useEffect } from 'react'

const API = 'https://legado-digital-production.up.railway.app'

function Emergencia() {
  const [datos, setDatos] = useState(null)
  const [cargando, setCargando] = useState(true)
  const [error, setError] = useState('')

  useEffect(() => {
    const params = new URLSearchParams(window.location.search)
    const uid = params.get('uid')
    if (!uid) { setError('QR no válido'); setCargando(false); return }
    fetch(`${API}/api/emergencia/${uid}`)
      .then(r => r.json())
      .then(data => {
        if (!data.ok) { setError('No se encontró información'); return }
        setDatos(data.datos)
      })
      .catch(() => setError('Error al cargar la información'))
      .finally(() => setCargando(false))
  }, [])

  if (cargando) return (
    <div style={estilos.pagina}>
      <div style={estilos.card}>
        <p style={{ textAlign: 'center', color: '#8B6F47' }}>Cargando información médica...</p>
      </div>
    </div>
  )

  if (error) return (
    <div style={estilos.pagina}>
      <div style={estilos.card}>
        <div style={estilos.headerRojo}>
          <span style={{ fontSize: '32px' }}>⚠️</span>
          <h1 style={{ color: '#FAF8F5', fontSize: '20px', margin: 0 }}>ETERN-ME</h1>
        </div>
        <p style={{ textAlign: 'center', color: '#8B2E0F', padding: '24px' }}>{error}</p>
      </div>
    </div>
  )

  return (
    <div style={estilos.pagina}>
      <div style={estilos.card}>
        <div style={estilos.headerRojo}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
            <img src="/logo-circulo.png" alt="ETERN-ME" style={{ width: '40px', height: '40px', borderRadius: '50%' }} />
            <div>
              <div style={{ color: '#FAF8F5', fontSize: '16px', fontWeight: '700' }}>ETERN-ME</div>
              <div style={{ color: '#C4A882', fontSize: '12px' }}>Información de emergencia</div>
            </div>
          </div>
          <div style={{ backgroundColor: '#8B2E0F', padding: '6px 12px', borderRadius: '20px' }}>
            <span style={{ color: '#FAF8F5', fontSize: '12px', fontWeight: '700' }}>🚨 EMERGENCIA</span>
          </div>
        </div>

        <div style={estilos.contenido}>
          {datos.nombre_completo && (
            <div style={estilos.nombre}>{datos.nombre_completo}</div>
          )}

          <div style={estilos.datoDestacado}>
            <div style={estilos.datoLabel}>🩸 Tipo de sangre</div>
            <div style={estilos.datoValorGrande}>{datos.tipo_sangre || 'No especificado'}</div>
          </div>

          <div style={estilos.divider} />

          <div style={estilos.dato}>
            <div style={estilos.datoLabel}>👨‍⚕️ Médico de cabecera</div>
            <div style={estilos.datoValor}>{datos.medico_cabecera || 'No especificado'}</div>
          </div>

          <div style={estilos.dato}>
            <div style={estilos.datoLabel}>📞 Contacto de emergencia</div>
            <div style={estilos.datoValor}>{datos.contacto_emergencia || 'No especificado'}</div>
          </div>

          <div style={estilos.dato}>
            <div style={estilos.datoLabel}>📱 Teléfono</div>
            <div style={estilos.datoValor}>{datos.telefono || 'No especificado'}</div>
          </div>

          {datos.direccion && (
            <div style={estilos.dato}>
              <div style={estilos.datoLabel}>📍 Dirección</div>
              <div style={estilos.datoValor}>{datos.direccion}</div>
            </div>
          )}

          <div style={estilos.footer}>
            <p style={{ fontSize: '11px', color: '#8B6F47', textAlign: 'center', margin: 0 }}>
              Información proporcionada por el titular a través de ETERN-ME · etern-me.com
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}

const estilos = {
  pagina: { minHeight: '100vh', backgroundColor: '#FAF8F5', display: 'flex', alignItems: 'flex-start', justifyContent: 'center', padding: '16px' },
  card: { width: '100%', maxWidth: '420px', backgroundColor: '#FFFFFF', borderRadius: '16px', overflow: 'hidden', boxShadow: '0 4px 24px rgba(44,24,16,0.12)', border: '1px solid #E8E0D5' },
  headerRojo: { backgroundColor: '#2C1810', padding: '20px 16px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' },
  contenido: { padding: '20px 16px' },
  nombre: { fontSize: '22px', fontWeight: '700', color: '#2C1810', textAlign: 'center', marginBottom: '20px' },
  datoDestacado: { backgroundColor: '#FDF0EC', borderRadius: '12px', padding: '16px', textAlign: 'center', marginBottom: '16px', border: '2px solid #8B2E0F' },
  datoLabel: { fontSize: '12px', color: '#8B6F47', fontWeight: '600', marginBottom: '4px', textTransform: 'uppercase', letterSpacing: '0.05em' },
  datoValorGrande: { fontSize: '40px', fontWeight: '800', color: '#8B2E0F', letterSpacing: '-1px' },
  divider: { height: '1px', backgroundColor: '#E8E0D5', margin: '16px 0' },
  dato: { marginBottom: '14px' },
  datoValor: { fontSize: '16px', color: '#2C1810', fontWeight: '500', marginTop: '2px' },
  footer: { marginTop: '20px', paddingTop: '16px', borderTop: '1px solid #E8E0D5' },
}

export default Emergencia
